import { Route, Routes } from "react-router-dom";
import MainLayout from "components/layouts/main-layout";
import Attendees from "containers/user-management/attendees/listing";
import Hosts from "containers/user-management/hosts/listing";
import Ambassadors from "containers/user-management/ambassadors/listing";
import AllRequests from "containers/user-management/ambassadors/requests/listing";
import DashboardHome from "containers/dashboard";
import Minors from "containers/user-management/minors/listing";
import RSVPS from "containers/user-management/rsvp/listing";
import Subscriptions from "containers/user-management/hosts/subscription/listing";
import Subscribers from "containers/user-management/hosts/subscription/subscribers";
import CreateHost from "containers/user-management/hosts/create";
import ViewHost from "containers/user-management/hosts/view";
import ViewEventDetail from "containers/user-management/hosts/view/event-detail";
import ViewAttendence from "containers/user-management/hosts/view/view-attendance";
import ViewAttendee from "containers/user-management/attendees/view";
import AttendeEvents from "containers/user-management/attendees/view/attende-events";
import ViewAttendeEventDetail from "containers/user-management/attendees/view/event-detail";
import ViewMinors from "containers/user-management/minors/view";
import ViewRSVP from "containers/user-management/rsvp/view";
import ViewRSVPEventDetail from "containers/user-management/rsvp/view/event-detail";
import ViewRsvpAttendance from "containers/user-management/rsvp/view/view-attendance";
import ViewAmbassador from "containers/user-management/ambassadors/view";
import ExperiencesListing from "containers/Experiences-Events/listing";
import ViewExperienceEventDetail from "containers/Experiences-Events/view";
import Communities from "containers/Communities/listing";
import ViewCommunity from "containers/Communities/view";
import ResourceLibraryListing from "containers/resource-library/listing";
import CreateResourceLibrary from "containers/resource-library/create";
import EditResourceLibrary from "containers/resource-library/edit";
import CupGratitudeListing from "containers/cup-of-gratitude/listing";
import CupGratitudeCreate from "containers/cup-of-gratitude/create";
import ViewMinorEventDetail from "containers/user-management/minors/view/event-detail";
import MinorEvents from "containers/user-management/minors/view/minor-events";
import CupGratitudeEdit from "containers/cup-of-gratitude/edit";
import BusinessManagementListing from "containers/business-management/listing";
import TeamMemberListing from "containers/team-management/team-member/listing";
import CreateTeamMember from "containers/team-management/team-member/create";
import NotificationListing from "containers/notification";
import ViewExperienceAttendance from "containers/Experiences-Events/view/view-attendance";
import PolicyAgreement from "containers/policy-agreement/listing";
import RoleManagementListing from "containers/team-management/role-management/listing";
import CreateRole from "containers/team-management/role-management/create";
import EditPolicy from "containers/policy-agreement/edit";
import InitialSubmission from "containers/user-management/ambassadors/requests/view";
import CreateEventBadge from "containers/badge-management/event-badge/create";
import CreateAchievementBadges from "containers/badge-management/achievement-badges/create";
import EditTeamMember from "containers/team-management/team-member/edit";
import ViewBusinessDetail from "containers/business-management/view";
import AmbassadorWallets from "containers/master-portal/product-items/listing";
import TeamMemberView from "containers/team-management/team-member/view";
import ViewTeamMember from "containers/team-management/team-member/view";
import ProductItems from "containers/master-portal/product-items/listing";
import ProductItemsCreate from "containers/master-portal/product-items/create";
import ProductItemEdit from "containers/master-portal/product-items/edit";
import ProductRequests from "containers/master-portal/order-requests/listing";
import OrderRequests from "containers/master-portal/order-requests/listing";
import ViewOrderRequest from "containers/master-portal/order-requests/view";
import BagdeListing from "containers/badge-management/event-badge/listing";
import EventBadgeListing from "containers/badge-management/event-badge/listing";
import AchievementBadgeListing from "containers/badge-management/achievement-badges/listing";
import AmbassadorRequest from "containers/user-management/ambassadors/requests/view";
import ViewAmbassadorEventDetail from "containers/user-management/ambassadors/view/event-detail";
import EditRole from "containers/team-management/role-management/edit";
import ProtectedRoute from "guards/protected-routes";
import { sitePermissions } from "utils/helpers/enums/permissions.enum";
import { siteRoutes } from "utils/helpers/enums/routes.enum";
import NotFound from "containers/not-found";
import CoreConceptBadgeListing from "containers/badge-management/core-concept-badges/listing";
import CreateCoreConceptBadge from "containers/badge-management/core-concept-badges/create";
import AmbassadorExperiencesListing from "containers/user-management/ambassadors/ambassador-experiences/listing";
import CreateAmbassadorExperience from "containers/user-management/ambassadors/ambassador-experiences/create";
import AmbassadorExperiencesView from "containers/user-management/ambassadors/ambassador-experiences/view";
import ViewExperienceParticipants from "containers/user-management/ambassadors/ambassador-experiences/view/participants";
import SubscriptionListing from "containers/host-management/manage-subscription/listing";
import CancelEventsListing from "containers/host-management/cancel-events/listing";

const routes = [
  {
    path: "/",
    element: <DashboardHome />,
    permission: sitePermissions.dashboardRead,
  },
  {
    path: siteRoutes.attendess,
    element: <Attendees />,
    permission: sitePermissions.attendeeList,
  },
  {
    path: siteRoutes.hosts,
    element: <Hosts />,
    permission: sitePermissions.hostList,
  },
  {
    path: siteRoutes.ambassadors,
    element: <Ambassadors />,
    permission: sitePermissions.ambassadorList,
  },
  {
    path: siteRoutes.allRequests,
    element: <AllRequests />,
    permission: sitePermissions.ambassadorRequestList,
  },
  {
    path: siteRoutes.viewAmbassador,
    element: <ViewAmbassador />,
    permission: sitePermissions.ambassadorRead,
  },
  {
    path: siteRoutes.requestDetail,
    element: <AmbassadorRequest />,
  },
  {
    path: siteRoutes.viewAmbassadorEventDetail,
    element: <ViewAmbassadorEventDetail />,
  },
  {
    path: siteRoutes.ambassadorExperiencesListing,
    element: <AmbassadorExperiencesListing />,
    // permission: sitePermissions.ambassadorExperiencesList,
  },
  {
    path: siteRoutes.createAmbassadorExperience,
    element: <CreateAmbassadorExperience />,
  },
  {
    path: siteRoutes.viewAmbassadorExperiencesDetail,
    element: <AmbassadorExperiencesView />,
  },
  {
    path: siteRoutes.viewAmbassadorExperiencesParticipants,
    element: <ViewExperienceParticipants />,
  },
  {
    path: siteRoutes.minors,
    element: <Minors />,
    permission: sitePermissions.minorList,
  },
  {
    path: siteRoutes.rsvps,
    element: <RSVPS />,
    permission: sitePermissions.rsvpList,
  },
  {
    path: siteRoutes.ambassadors,
    element: <Ambassadors />,
    permission: sitePermissions.ambassadorList,
  },
  // {
  //   path: siteRoutes.hostSubscription,
  //   element: <Subscriptions />,
  //   permission: sitePermissions.hostSubscriptionList,
  // },
  // {
  //   path: siteRoutes.hostSubscribers,
  //   element: <Subscribers />,
  // },
  {
    path: siteRoutes.createNewHost,
    element: <CreateHost />,
  },
  {
    path: siteRoutes.viewHost,
    element: <ViewHost />,
    permission: sitePermissions.hostRead,
  },
  {
    path: siteRoutes.hostEventDetailView,
    element: <ViewEventDetail />,
  },
  {
    path: siteRoutes.hostAttendenceView,
    element: <ViewAttendence />,
  },
  {
    path: siteRoutes.attendeeView,
    element: <ViewAttendee />,
    permission: sitePermissions.attendeeRead,
  },
  {
    path: siteRoutes.attendeeEvents,
    element: <AttendeEvents />,
  },
  {
    path: siteRoutes.attendeeEventsDetail,
    element: <ViewAttendeEventDetail />,
  },
  {
    path: siteRoutes.viewMinors,
    element: <ViewMinors />,
    permission: sitePermissions.minorRead,
  },
  {
    path: siteRoutes.viewMinors,
    element: <ViewMinors />,
    permission: sitePermissions.minorRead,
  },
  {
    path: siteRoutes.minorEvents,
    element: <MinorEvents />,
  },
  {
    path: siteRoutes.minorEventsDetail,
    element: <ViewMinorEventDetail />,
  },
  {
    path: siteRoutes.viewRSVP,
    element: <ViewRSVP />,
    permission: sitePermissions.rsvpRead,
  },
  {
    path: siteRoutes.rsvpEventsDetail,
    element: <ViewRSVPEventDetail />,
  },
  {
    path: siteRoutes.rsvpEventAttendance,
    element: <ViewRsvpAttendance />,
  },
  {
    path: siteRoutes.experiences,
    element: <ExperiencesListing />,
    permission: sitePermissions.experiencesList,
  },
  {
    path: siteRoutes.viewExperienceDetail,
    element: <ViewExperienceEventDetail />,
  },
  {
    path: siteRoutes.viewExperienceAttendance,
    element: <ViewExperienceAttendance />,
  },
  {
    path: siteRoutes.communitiesListing,
    element: <Communities />,
    permission: sitePermissions.communitiesList,
  },
  {
    path: siteRoutes.communitiesView,
    element: <ViewCommunity />,
    permission: sitePermissions.communitiesRead,
  },
  {
    path: siteRoutes.resourceLibraryListing,
    element: <ResourceLibraryListing />,
    permission: sitePermissions.resourceLibraryList,
  },
  {
    path: siteRoutes.createResourceLibrary,
    element: <CreateResourceLibrary />,
    permission: sitePermissions.resourceLibraryCreate,
  },
  {
    path: siteRoutes.editResourceLibrary,
    element: <EditResourceLibrary />,
    permission: sitePermissions.resourceLibraryUpdate,
  },
  {
    path: siteRoutes.cupOfGratitudeListing,
    element: <CupGratitudeListing />,
    permission: sitePermissions.cupOfGratitudeList,
  },
  {
    path: siteRoutes.cupOfGratitudeCreate,
    element: <CupGratitudeCreate />,
    permission: sitePermissions.cupOfGratitudeCreate,
  },
  {
    path: siteRoutes.cupOfGratitudeEdit,
    element: <CupGratitudeEdit />,
    permission: sitePermissions.cupOfGratitudeUpdate,
  },
  {
    path: siteRoutes.businessManagementListing,
    element: <BusinessManagementListing />,
    permission: sitePermissions.businessList,
  },
  {
    path: siteRoutes.viewBusinessDetail,
    element: <ViewBusinessDetail />,
    permission: sitePermissions.businessRead,
  },
  {
    path: siteRoutes.teamMemberListing,
    element: <TeamMemberListing />,
    permission: sitePermissions.teamMembersList,
  },
  {
    path: siteRoutes.createTeamMember,
    element: <CreateTeamMember />,
    permission: sitePermissions.teamMembersCreate,
  },
  {
    path: siteRoutes.editTeamMember,
    element: <EditTeamMember />,
    permission: sitePermissions.teamMembersUpdate,
  },

  {
    path: siteRoutes.viewTeamMember,
    element: <ViewTeamMember />,
    permission: sitePermissions.teamMembersRead,
  },
  {
    path: siteRoutes.roleManagementListing,
    element: <RoleManagementListing />,
    permission: sitePermissions.roleManagementList,
  },
  {
    path: siteRoutes.createRole,
    element: <CreateRole />,
    permission: sitePermissions.roleManagementCreate,
  },
  {
    path: siteRoutes.editRole,
    element: <EditRole />,
    permission: sitePermissions.roleManagementUpdate,
  },
  {
    path: siteRoutes.eventBadgeListing,
    element: <EventBadgeListing />,
    permission: sitePermissions.eventBadgeList,
  },
  {
    path: siteRoutes.createEventBadge,
    element: <CreateEventBadge />,
    permission: sitePermissions.eventBadgeCreate,
  },
  {
    path: siteRoutes.achievementBadgeListing,
    element: <AchievementBadgeListing />,
    permission: sitePermissions.achievementBadgeList,
  },
  {
    path: siteRoutes.createAchievementBadge,
    element: <CreateAchievementBadges />,
    permission: sitePermissions.achievementBadgeCreate,
  },
  {
    path: siteRoutes.coreConceptBadgeListing,
    element: <CoreConceptBadgeListing />,
    // permission: sitePermissions.coreConceptBadgeListing,
  },
  {
    path: siteRoutes.createCoreConceptBadge,
    element: <CreateCoreConceptBadge />,
    // permission: sitePermissions.coreConceptBadgeListing,
  },

  {
    path: siteRoutes.policyAgreement,
    element: <PolicyAgreement />,
    permission: sitePermissions.policyAgreementList,
  },
  {
    path: siteRoutes.editPolicy,
    element: <EditPolicy />,
    permission: sitePermissions.policyAgreementUpdate,
  },
  {
    path: siteRoutes.notificationListing,
    element: <NotificationListing />,
  },
  {
    path: siteRoutes.productItems,
    element: <ProductItems />,
    permission: sitePermissions.productItemsList,
  },
  {
    path: siteRoutes.productItemsCreate,
    element: <ProductItemsCreate />,
    permission: sitePermissions.productItemsCreate,
  },
  {
    path: siteRoutes.productItemEdit,
    element: <ProductItemEdit />,
    permission: sitePermissions.productItemsUpdate,
  },
  {
    path: siteRoutes.orderRequests,
    element: <OrderRequests />,
    permission: sitePermissions.orderRequestsList,
  },
  {
    path: siteRoutes.viewOrderRequest,
    element: <ViewOrderRequest />,
    permission: sitePermissions.orderRequestsRead,
  },
  {
    path: siteRoutes.hostSubscription,
    element: <SubscriptionListing />,
    // permission: sitePermissions.hostSubscriptionList,
  },
  {
    path: siteRoutes.hostCancelEventsListing,
    element: <CancelEventsListing />,
  },
];

const DashboardRoutes = () => {
  return (
    <MainLayout>
      <Routes>
        {/* <Route element={<ProtectedRoute />}>
          <Route path="/" element={<DashboardHome />} />
          <Route path="*" element={<div>Not Found</div>} />
          <Route path="/user-management/attendees" element={<Attendees />} />
          <Route path="/user-management/hosts" element={<Hosts />} />
          <Route
            path="/user-management/ambassadors"
            element={<Ambassadors />}
          />
          <Route
            path="/user-management/ambassadors/all-request"
            element={<AllRequests />}
          />
          <Route
            path="/user-management/ambassadors/view-ambassador"
            element={<ViewAmbassador />}
          />

          <Route
            path="/user-management/ambassadors/all-request/view"
            element={<AmbassadorRequest />}
          />

          <Route
            path="/user-management/ambassadors/view-ambassador/event-detail-view"
            element={<ViewAmbassadorEventDetail />}
          />

          <Route path="/user-management/minors" element={<Minors />} />
          <Route path="/user-management/rsvps" element={<RSVPS />} />
          <Route
            path="/user-management/host/subscriptions"
            element={<Subscriptions />}
          />
          <Route
            path="/user-management/host/subscribers"
            element={<Subscribers />}
          />
          <Route
            path="/user-management/host/create-new-host"
            element={<CreateHost />}
          />
          <Route
            path="/user-management/host/view-host"
            element={<ViewHost />}
          />
          <Route
            path="/user-management/host/view-host/event-detail-view"
            element={<ViewEventDetail />}
          />

          <Route
            path="/user-management/host/view-host/event-detail-view/attendence-view"
            element={<ViewAttendence />}
          />
          <Route
            path="/user-management/attendees/view-attendee"
            element={<ViewAttendee />}
          />
          <Route
            path="/user-management/attendees/view-attendee/events"
            element={<AttendeEvents />}
          />

          <Route
            path="/user-management/attendees/view-attendee/events/view-event-details"
            element={<ViewAttendeEventDetail />}
          />

          <Route
            path="/user-management/minors/view-minors"
            element={<ViewMinors />}
          />

          <Route
            path="/user-management/minors/view-minors/events"
            element={<MinorEvents />}
          />
          <Route
            path="/user-management/minors/view-minors/events/view-event-details"
            element={<ViewMinorEventDetail />}
          />

          <Route
            path="/user-management/rsvp/view-rsvp"
            element={<ViewRSVP />}
          />
          <Route
            path="/user-management/rsvp/view-rsvp/view-event-detail"
            element={<ViewRSVPEventDetail />}
          />
          <Route
            path="/user-management/rsvp/view-rsvp/view-event-detail/rsvp-attendance"
            element={<ViewRsvpAttendance />}
          />
          <Route path="/experiences" element={<ExperiencesListing />} />

          <Route
            path="/experiences/view-experiences-detail"
            element={<ViewExperienceEventDetail />}
          />

          <Route
            path="/experiences/view-experiences-detail/attendence-view"
            element={<ViewExperienceAttendance />}
          />

          <Route path="/communities-listing" element={<Communities />} />
          <Route
            path="/communities-listing/view-community"
            element={<ViewCommunity />}
          />

          <Route
            path="/resource-library-listing"
            element={<ResourceLibraryListing />}
          />

          <Route
            path="/resource-library/create-resource-library"
            element={<CreateResourceLibrary />}
          />

          <Route
            path="/resource-library/edit-resource-library"
            element={<EditResourceLibrary />}
          />

          <Route
            path="/cup-of-gratitude-listing"
            element={<CupGratitudeListing />}
          />
          <Route
            path="/cup-of-gratitude-create"
            element={<CupGratitudeCreate />}
          />

          <Route path="/cup-of-gratitude-edit" element={<CupGratitudeEdit />} />
          <Route
            path="/business-management-listing"
            element={<BusinessManagementListing />}
          />

          <Route
            path="/business-management/view-business-detail"
            element={<ViewBusinessDetail />}
          />

          <Route
            path="/team-management/team-member-listing"
            element={<TeamMemberListing />}
          />

          <Route
            path="/team-management/create-team-member"
            element={<CreateTeamMember />}
          />

          <Route
            path="/team-management/edit-team-member"
            element={<EditTeamMember />}
          />

          <Route
            path="/team-management/view-team-member"
            element={<ViewTeamMember />}
          />

          <Route
            path="/team-management/role-management-listing"
            element={<RoleManagementListing />}
          />

          <Route path="/team-management/create-role" element={<CreateRole />} />
          <Route path="/team-management/edit-role" element={<EditRole />} />

          <Route
            path="/badge-management/event-badge-listing"
            element={<EventBadgeListing />}
          />
          <Route
            path="/badge-management/create-event-badge"
            element={<CreateEventBadge />}
          />
          <Route
            path="/badge-management/achievement-badge-listing"
            element={<AchievementBadgeListing />}
          />

          <Route
            path="/badge-management/create-achievement-badge"
            element={<CreateAchievementBadges />}
          />

          <Route path="/policy-agreement" element={<PolicyAgreement />} />
          <Route path="/edit-policy-agreement" element={<EditPolicy />} />
          <Route path="/notifications" element={<NotificationListing />} />
          <Route
            path="/master-portal/product-items/listing-product-items"
            element={<ProductItems />}
          />
          <Route
            path="/master-portal/product-items/create-product-items"
            element={<ProductItemsCreate />}
          />

          <Route
            path="/master-portal/product-items/edit-product-items"
            element={<ProductItemEdit />}
          />

          <Route
            path="/master-portal/order-requests/listing-order-requests"
            element={<OrderRequests />}
          />

          <Route
            path="/master-portal/order-requests/view-order-request"
            element={<ViewOrderRequest />}
          />
        </Route> */}
      </Routes>
      <Routes>
        {routes.map(({ path, element, permission }, index) => (
          <Route
            key={index}
            element={<ProtectedRoute permission={permission} />}
          >
            <Route path={path} element={element} />
          </Route>
        ))}
        {/* NotFound route - accessible without permission check */}
        <Route path={siteRoutes.notFound} element={<NotFound />} />
        {/* Catch-all route for non-existent paths */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </MainLayout>
  );
};

export default DashboardRoutes;
